import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';

const CityField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return <FullInfoField label="cityLabel" value={restaurantForFullInfo?.city.name} />;
};

export default CityField;
